export const entityName = 'marker_group'

export default {
  entityName
}
